import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function ResponsibleGaming() {
  return (
    <>
      <SEOHead
        title="Responsible Gaming – All Yono Games"
        description="Learn about responsible gaming practices. Tips for safe play, setting limits, recognizing problem gaming, and guidance for Indian players. Adults only. Play responsibly."
        keywords="Responsible Gaming, Safe Gaming India, Gaming Addiction Help, Yono Games Safety, Play Responsibly"
      />

      <Header />

      <main>
        <div className="px-4 py-6">
          <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-[10px] font-semibold mb-2">
            Play Safe
          </span>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-5">
            Responsible Gaming
          </h1>

          <div className="space-y-4 text-foreground-600 text-[13px] leading-relaxed">
            <p>
              At All Yono Games, we believe gaming should always be a fun and entertaining activity. We are committed to promoting responsible gaming practices and providing guidance to help players maintain a healthy relationship with mobile gaming.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Adults Only</h2>
            <p>
              This website and the games listed are intended for users aged 18 and above. We do not promote or encourage gaming by minors. If you are under 18, please do not use this website or download any listed applications.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Tips for Responsible Gaming</h2>
            <ul className="space-y-1.5 list-disc pl-5">
              <li>Set a budget before you start playing and stick to it</li>
              <li>Decide on time limits for your gaming sessions</li>
              <li>Never chase losses — accept them as part of the entertainment cost</li>
              <li>Do not borrow money to play games</li>
              <li>Do not play with borrowed money or funds needed for essential expenses</li>
              <li>Take regular breaks during gaming sessions</li>
              <li>Balance gaming with other activities and hobbies</li>
              <li>Never play when you are upset, stressed, or under the influence</li>
              <li>Keep track of the time and money you spend on gaming</li>
              <li>Set deposit limits to control your spending</li>
            </ul>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Warning Signs</h2>
            <p>It is important to recognize when gaming stops being entertainment. Watch for these warning signs:</p>
            <ul className="space-y-1.5 list-disc pl-5">
              <li>Spending more time or money on gaming than you planned</li>
              <li>Neglecting work, studies, or family responsibilities</li>
              <li>Lying to family or friends about your gaming habits</li>
              <li>Borrowing money or selling possessions to fund gaming</li>
              <li>Feeling anxious or irritable when not playing</li>
              <li>Trying unsuccessfully to cut back or stop</li>
              <li>Using gaming as an escape from problems or negative feelings</li>
              <li>Gaming causing financial or personal problems in your life</li>
            </ul>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Stop When Needed</h2>
            <p>
              Stop gaming when it causes financial difficulties, affects your personal relationships, or impacts your mental wellbeing. Gaming should never come at the expense of your health, finances, or relationships. If you feel your gaming habits are becoming difficult to manage, take a break and seek support.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Understand the Risks</h2>
            <p>
              Real-money gaming involves financial risk. You may lose the money you deposit. Never deposit money you cannot afford to lose. Gaming outcomes are based on chance, and there is no guaranteed way to win. Treat gaming as a paid form of entertainment, not as a way to earn income or recover financial losses.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Self-Help Tools</h2>
            <p>Many gaming platforms offer built-in tools to help you manage your play:</p>
            <ul className="space-y-1.5 list-disc pl-5">
              <li>Deposit limits — set maximum amounts you can deposit daily, weekly, or monthly</li>
              <li>Time limits — control how long you can play in a single session</li>
              <li>Self-exclusion — temporarily or permanently block access to your account</li>
              <li>Reality checks — receive reminders about how long you have been playing</li>
            </ul>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Seeking Help</h2>
            <p>
              If you or someone you know is struggling with gaming-related issues, professional help is available. Consider reaching out to mental health professionals, addiction helplines, or support groups in your area. Many organizations provide free and confidential support for individuals affected by problem gaming.
            </p>
          </div>

          <div className="mt-6 p-4 bg-accent-50 border border-accent-200 rounded-xl">
            <p className="text-accent-800 text-[12px] font-medium">
              <i className="ri-information-line mr-1"></i>
              Remember: Gaming is entertainment, not a financial strategy. Play responsibly, set limits, and stay within your means. Adults only.
            </p>
          </div>

          <div className="mt-6 text-center">
            <Link
              to="/games"
              className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-primary-500 text-white rounded-full text-[13px] font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Browse Games Responsibly
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}